import React, { Component } from 'react'
import './Chip.css'
import PropTypes from 'prop-types'

class Chip extends Component {

    onClick = event => {
        this.props.onChipDelete(event.target.id)
    }

    render () {
        return (
            <div className="chip m-2" data-testid="Chip_divId_test">
                {this.props.name}
                <span data-testid="Chip_spanId_test" id={this.props.id} onClick={this.onClick} className="closebtn">&times;</span>
            </div>
        )
    }
}

Chip.propTypes = {
    onChipDelete: PropTypes.any,
    id: PropTypes.any,
    name: PropTypes.any
}

export default Chip
